<script setup>
defineProps({
    type: {
        type: String,
        default: 'submit',
    },
});
</script>

<template>
    <button
        :type="type"
        class="button button-primary button-large"
    >
        <slot />
    </button>
</template>
